import Vue from 'vue'
import App from './App'
import router from './router'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
// require('firebase/firestore')
// コメントアウトした箇所は登録確認メール送信機能（現状不要だが念のため残してある）
// import * as nodemailer from 'nodemailer'
// import * as functions from 'firebase-functions'

var firebaseConfig = {
  apiKey: 'AIzaSyCLtmUp87BPrFDexGl1GPoFXzCImtSiwR0',
  authDomain: 'mpgr-3.firebaseapp.com',
  databaseURL: 'https://mpgr-3.firebaseio.com',
  projectId: 'mpgr-3',
  storageBucket: 'mpgr-3.appspot.com',
  messagingSenderId: '832254591684',
  appId: '1:832254591684:web:65827aab73435575173f91',
  measurementId: 'G-RW3LVDPSN0'
}
firebase.initializeApp(firebaseConfig)

// Databaseのexport（new Vueの前に実行する）
export const db = firebase.firestore()
// export const fbFunctions = firebase.functions()

Vue.use(firestorePlugin)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// メール送信機能
// const gmailEmail = functions.config().gmail.email
// const gmailPassword = functions.config().gmail.password
// const mailTransport = nodemailer.createTransport({
//   service: 'gmail',
//   auth: {
//     user: gmailEmail,
//     pass: gmailPassword,
//   },
// })

// exports.sendMail = functions.https.onCall((data, context) => {
//   const name = data.name;
//   let email = {
//     from: gmailEmail,
//     to: data.email,
//     subject: 'MPGR3 参加登録ありがとうございます',
//     text:
//     `
//       ${name} 様
//       https://mpgr-3.firebaseapp.com/ にて、MPGR3の参加登録ありがとうございます。
//       このメールは登録されたメールアドレスが有効であるかどうかを確認するためのものです。
//
//     `
//   }
//   mailTransport.sendMail(email, (err, info) => {
//     if (err) {
//         return console.log(err)
//     }
//     return console.log('success')
//   })
// })



// WEBPACK FOOTER //
// ./src/main.js